/**
 * Created by renlaydel on 28/11/2017.
 */
import * as ActionType from '../../constants/constant_action_types';
import * as TransactionStatus from '../../constants/constant_transaction_status';


const INITIAL_STATE = {
  data : {
    status: { _id: TransactionStatus.OPEN },
    exchange_rate : 1
  },
  modal: {
    state : 'hide',
    header: '',
    index : 0
  },
};

export default function inventoryReturnReducer( state = INITIAL_STATE, action ) {
  switch ( action.type ) {
    case ActionType.SET_INVENTORY_RETURN: {
      return {
        ...state, data: { ...action.data }
      };
    }

    case ActionType.CLEAR_INVENTORY_RETURN: {
      return {
        ...INITIAL_STATE
      }
    }

    case ActionType.OPEN_PURCHASE_RETURN_REFERENCE_ID_MODAL: {
      return {
        ...state, modal: {
          state : action.state,
          header: action.header,
          index : action.index
        }
      }
    }

    default:
      return state;
  }
}